<template>
  <div id="custom_template">
    <langham-header
      :banner-desktop="config.bannerDesktop"
      :banner-mobile="config.bannerMobile"
      :connected="load_states.connected"
    />

    <main class="container-fluid">
      <langham-form
        v-if="load_states.has_custom_portal"
        :property-name="config.propertyName"
        :form-variant="config.formVariant"
        :registration_methods="registration_methods"
        v-on:emitRegistrationMethodData="emitRegistrationMethodData"
      />

      <div v-if="load_states.error">
        <div class="error-container">
          <p>{{ error ? error.message : 'Error' }}</p>
          <a v-on:click="changeLoadState('has_custom_portal')" class="error-button">Please try again</a>
        </div>
      </div>

      <div v-if="load_states.loading">
        <div class="loading-container">
          <div class="loader"></div>
          <p>Loading</p>
        </div>
      </div>

      <langham-connected
        v-if="load_states.connected"
        :portal="portal"
        :connection_data="connection_data"
        :chat-url="config.chatUrl"
        :qr-code="config.qrCode"
      />
    </main>

    <langham-footer />
  </div>
</template>

<script>
import LanghamForm from '@/components/custom/_langham2026/LanghamForm';
import LanghamConnected from '@/components/custom/_langham2026/LanghamConnected';
import LanghamHeader from '@/components/custom/_langham2026/LanghamHeader';
import LanghamFooter from '@/components/custom/_langham2026/LanghamFooter';

export default {
  name: 'langham-template',
  props: [
    'portal',
    'connection_data',
    'load_states',
    'error',
    'config',
  ],
  components: {
    'langham-form': LanghamForm,
    'langham-connected': LanghamConnected,
    'langham-header': LanghamHeader,
    'langham-footer': LanghamFooter,
  },
  data() {
    return {
      registration_methods: [],
      terms_of_service: `<center><b>TERMS AND CONDITIONS<br>OF INTERNET USE</b><br><br><b>IMPORTANT! PLEASE READ CAREFULLY BEFORE USING. YOUR USE OF THE SERVICES IS YOUR ACKNOWLEDGMENT AND AGREEMENT THAT YOU AGREE WITH THE TERMS SET FORTH BELOW.</b></center>`,
    };
  },
  mounted() {
    this.generateRegistrationMethods();
  },
  methods: {
    generateRegistrationMethods() {
      this.registration_methods = [];

      for (const rm of this.portal.registration_methods) {
        for (const rateplan of rm.rate_plans) {
          this.registration_methods.push({
            name: rm.free == 0 ? rateplan.rate_plan_name : rm.registration_method,
            type: 'rateplan',
            registration_method_id: rm.registration_method_id,
            id: rateplan.rateplan_id,
            price: rateplan.price,
            duration: rateplan.duration,
            speed_upload: rateplan.speed_upload,
            speed_download: rateplan.speed_download,
            additional_devices: rateplan.additional_devices,
            terms_of_service: this.terms_of_service,
          });
        }
      }

      if (this.portal.access_codes.length > 0) {
        this.registration_methods.push({
          name: 'Access Code',
          type: 'accesscode',
          registration_method_id: 4,
          terms_of_service: this.terms_of_service,
        });
      }
    },
    emitRegistrationMethodData(emitted) {
      this.$emit('emitRegistrationMethodData', emitted);
    },
    changeLoadState(state) {
      for (const load_state in this.load_states) {
        this.load_states[load_state] = (state == load_state);
      }
    },
  },
};
</script>

<style src="./langham2026.css"></style>
